import { render } from "./SelectClinic.vue?vue&type=template&id=5ef00326"
import script from "./SelectClinic.vue?vue&type=script&lang=js"
export * from "./SelectClinic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__